// LIBRARIES
import styled, { css } from "styled-components";
import { Modal } from "@mui/material";

// MISC
import { COLORS } from "constants/styleVariables";
import { CircularProgress } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

export const ModalDialog = styled(Modal)(
  ({ type }) => css`
    && {
      .MuiBackdrop-root {
        background-color: ${type ? type : "rgba(0, 0, 0, 0.5)"};
      }
    }
  `
);

export const ChildModalIdContainer = styled.img`
  width: 580px;
  height: 340px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  border-radius: 20px;
`;

export const ChildModalEquipmentPhotoContainer = styled.img`
  width: 390px;
  height: 690px;
  object-fit: contain;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  border-radius: 20px;
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 10;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;

export const ChildModalDialog = styled.div`
width: 390px;
height: 690px;
object-fit: contain;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
outline: none;
border-radius: 20px;
`

export const LoadingModalContainer = styled.div`
  width: 270px;
  height: 170px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  border-radius: 20px;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.rainbowIndigo};
  outline: none;
  border-radius: 20px;
  opacity: 0.7;
`;

export const LodingSign = styled(CircularProgress)`
  && {
    color: ${COLORS.terraCotta};
    opacity: 1 !important;
  }
`;
